import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorContext,
  type FormValidatorSettings
} from '@common';
import { toRaw } from 'vue';

export interface OnlyOneRequiredValidatorSettings extends FormValidatorSettings {
  otherFieldName: string;
  requiredInvalidMessage: string;
}

export type OnlyOneRequiredValidatorConfig = FormValidatorConfig<OnlyOneRequiredValidatorSettings>;

export class OnlyOneRequiredValidator extends FormValidator<OnlyOneRequiredValidatorSettings> {
  constructor() {
    super();
    this._name = 'onlyOneRequired';
    this._settings = {
      invalidMessage: 'form.validator.onlyOneRequired.invalidMessage',
      requiredInvalidMessage: 'form.validator.onlyOneRequired.requiredInvalidMessage',
      needTranslate: true,
      otherFieldName: ''
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    const values = toRaw(context.values);

    const attributes = values['attributes'];
    const otherFieldValue = attributes[this._settings.otherFieldName];

    if (otherFieldValue && value) {
      this._valid = false;
      this.addMessage(this._settings.invalidMessage);
    } else if (!otherFieldValue && !value) {
      this._valid = false;
      this.addMessage(this._settings.requiredInvalidMessage);
    }
  }
}
